/**
 * QueryClient (@tanstack/react-query v5) + фабрика ключей кэша.
 *
 * Ключи скоупятся по accountId + dealId — критично для мультитенантности
 * (accountId — amoCRM BigInt-строка, как в JWT-claim).
 *
 * Дефолты подобраны под iframe: не рефетчим на фокус (в iframe фокус скачет),
 * не ретраим 401/403 (их разрулит apiClient/refresh или это отказ прав).
 */

import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './apiClient';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error): boolean => {
        if (error instanceof ApiError && (error.status === 401 || error.status === 403 || error.status === 404)) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});

/**
 * Ключи кэша. Все запросы вкладки скоупятся по (accountId, dealId | paymentId).
 */
export const queryKeys = {
  payments: (accountId: string, dealId: string) => ['payments', accountId, dealId] as const,
  stats: (accountId: string, dealId: string) => ['stats', accountId, dealId] as const,
  history: (accountId: string, dealId: string, paymentId?: string) =>
    ['history', accountId, dealId, paymentId ?? 'all'] as const,
  events: (accountId: string, dealId: string) => ['events', accountId, dealId] as const,
  settings: (accountId: string) => ['settings', accountId] as const,
};
